"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.tabs.threads': 'Thread',
    'whatsapp.tabs.settings': 'Impostazioni',
    'whatsapp.tabs.groups': 'Gruppi',
    'whatsapp.tabs.directMessages': 'Messaggi diretti',
    'whatsapp.tabs.email': 'Email',
    'whatsapp.tabs.emailSettings': 'Impostazioni email',
};
